import ItemRelatorio from './ItemRelatorio'
import enhance from './ItemRelatorio.enhancer'

export default enhance(ItemRelatorio)



// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/components/ItemRelatorio/index.js